import * as C from './styles';

export const NotFound = () => {
    return(
        <C.Container>
            <h2>Sorry! Página não encontrada.</h2>
        </C.Container>
    );
}